
import { Vue, Component, Prop } from "nuxt-property-decorator";
import { faSearch } from "@fortawesome/pro-light-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";

@Component({
  name: "SpeakerNameFilters",
  computed: {
    faSearch: (): IconDefinition => faSearch,
  },
})
export default class SpeakerFilter extends Vue {
  @Prop() value!: Record<string, unknown>;

  speaker_name = this.value.full_name || "";

  company_name = this.value.company_name || "";

  change(): void {
    this.$emit("input", {
      ...this.value,
      full_name: this.speaker_name || undefined,
      company_name: this.company_name || undefined,
    });
    this.$emit("submit");
  }
}
